<template>
	<div class="comments">
		<transition name="fade" mode="out-in">
			<div class="comment" :key="activeIndex">
				<div class="comment--rating">
					<Stars />
				</div>
				<div class="comment--body">{{ comments[activeIndex].body }}</div>
				<div class="comment--name">{{ comments[activeIndex].name }}</div>
			</div>
		</transition>

		<div v-if="showPaginate" class="paginate">
			<span v-for="index in comments.length" :key="index" :class="{ active: index - 1 == activeIndex }"></span>
		</div>
	</div>
</template>

<script>
import { ref, onMounted, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import Stars from '@/components/Stars.vue'

export default {
	props: {
		showPaginate: {
			type: Boolean,
			default: true
		}
	},

	components: {
		Stars
	},

	setup() {
		const { t } = useI18n()
		let activeIndex = ref(0)

		const comments = computed(() => {
			return [
				{
					id: 'lost8',
					body: t('comments.theresa_hamilton.body'),
					name: t('comments.theresa_hamilton.name')
				},
				{
					id: 'easy',
					body: t('comments.jay_macdonald.body'),
					name: t('comments.jay_macdonald.name')
				},
				{
					id: 'lost5k',
					body: t('comments.sleepy.body'),
					name: t('comments.sleepy.name')
				},
				{
					id: 'on_track',
					body: t('comments.stevobobbio.body'),
					name: t('comments.stevobobbio.name')
				},
				{
					id: 'visualization',
					body: t('comments.alikat.body'),
					name: t('comments.alikat.name')
				}
			]
		})

		onMounted(() => {
			setInterval(() => {
				activeIndex.value = activeIndex.value + 1 == comments.value.length ? 0 : activeIndex.value + 1
			}, 4000)
		})

		return {
			t,
			activeIndex,
			comments
		}
	}
}
</script>

<style lang="scss">
.comments {
	margin-top: 1.2rem;
}

.comment {
	width: 100%;
	max-width: 90%;
	margin-left: auto;
	margin-right: auto;
	text-align: center;

	&--body {
		margin-top: 2px;
		font-size: 1.05rem;
		min-height: 3.15rem;
	}

	&--name {
		margin-top: 5px;
		opacity: 0.7;
	}
}

.paginate {
	display: flex;
	justify-content: center;
	margin-top: 15px;

	span {
		width: 6px;
		height: 6px;
		margin: 0 5px;
		border-radius: 50%;
		background-color: #000;
		opacity: 0.2;
		transition: opacity 0.3s;

		&.active {
			opacity: 1;
		}
	}
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
	opacity: 0;
}
</style>
